<template>
    <div v-if="showView" class="page-alert flex flex-center zindex-tip">
      <div class="page-body bg-white">
        <div class="page-header flex-row-align-center flex-row-justify-space-between">
          <p class="font-size-24 font-bold">纪事地点</p>
          <img class="cursor" src="@/assets/icon-lib-close-blue.png" alt="" @click="showView = false">
        </div>
        <!-- <div class="page-options">
          <div class="page-options-region-date flex-row-align-center">
            <div class="flex-row-align-center">
              <p class="font-size-12 font-color-999 space">显示{{ total }}中的{{ range.start }}-{{ range.end }}条</p>
              <p class="font-size-12 font-color-264480 space cursor" :class="currentPage==1?'disabel':''" @click="prePage">上一页</p>
              <p class="font-size-12 font-color-264480 cursor" :class="currentPage==pages?'disabel':''" @click="nextPage">下一页</p>
            </div>
          </div>
        </div> -->
  
        <div class="page-content bg-white">
  
          <div class="menu-content-item-list">
            <div v-if="currentRegion.parent" class="menu-content-item-list-item">
              <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5 sel">
                <p class="font-size-14 font-color-white">{{ currentRegion.parent.regionName }}</p>
                <p class="font-size-14 cate-sel-close flex-center cursor font-color-white" @click="selectLastRegion">x</p>
              </div>
            </div>
            <div v-for="cate in currentRegion.logs" :key="cate.id" class="menu-content-item-list-item" @click="selectRegion(cate)">
              <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="current.id == cate.id?'sel':''">
                <div class="flex">
                  <p v-if="currentRegion.parent" class="font-size-14 character">└</p>
                  <p class="font-size-14">{{ cate.regionName }}</p>
                </div>
                <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
              </div>
            </div>
          </div>
        </div>
  
        <div class="page-footer flex-center bg-white">
          <p class="bg-282B80 font-color-white flex-center font-size-14 radius-clip-5 btn cursor" @click="confirm">确定</p>
          <p class="bg-F3F4F9 font-color-264480 flex-center font-size-14 radius-clip-5 btn cursor" @click="showView = false">关闭</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  // import api from '../../../api/collections.js'
  import api from '@/api/collections.js'
  export default {
    data() {
      return {
        showView: false,
        currentRegion: null,
  
        reqParams: {},
  
        currentPage: 1,
        total: 0,
        pages: 0,
        range: { start: 0, end: 0 },
  
        regions: [],
        current: {
          id: '',
          data: ''
        }
      }
    },
    destroyed() {
      console.log('销毁')
    },
    methods: {
      show(data, type) {
        this.dataType = type
        this.reqParams = { size: 10, current: this.currentPage }
        for (const key in data) {
          if (key === 'current' || key === 'size' || key === 'sortType') {
            continue
          } else {
            this.reqParams[key] = data[key]
          }
        }
        this.request()
        this.showView = true
      },
      request() {
        this.reqParams.current = this.currentPage
        const that = this
        this.reqParams.tenantId = this.$store.getters.tenantId
        api.regionPage(this.reqParams).then(r => {
          that.total = r.data.total
          that.regions = r.data
          that.currentRegion = { parent: null, logs: r.data }
        })
      },
  
      selectRegion(v) {
        if (this.current.id === v.id) {
          return
        }
        this.current.id = v.id
        this.current.data = v
        if (v.children) {
          this.currentRegion = { parent: v, logs: v.children }
        }
      },
      selectLastRegion() {
        if (this.currentRegion.parent.parentId === 1) {
          this.currentRegion = { parent: null, logs: this.regions }
          this.current.id = ''
          this.current.data = ''
        } else {
          const parentId = this.currentRegion.parent.parentId
          this.findRegionsById(parentId, this.regions)
        }
      },
      findRegionsById(cid, cates) {
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.id === cid) {
            this.currentRegion = { parent: cate, logs: cate.children }
            return cate
          } else {
            if (cate.children) {
              this.findRegionsById(cid, cate.children)
            }
          }
        }
      },
      prePage() {
        if (this.currentPage > 1) {
          this.currentPage -= 1
          this.request()
        }
      },
      nextPage() {
        if (this.currentPage < this.pages) {
          this.currentPage += 1
          this.request()
        }
      },
      confirm() {
        this.showView = false
        if (this.current.id !== '') {
          this.$emit('select', { params: { areaAffected: this.current.data.regionCode }, display: this.current.data.regionName, type: 'areaAffected' })
        }
      },
      closeView() {
        this.total = 0
        this.currentPage = 1
        this.range.start = 0
        this.range.end = 0
        this.current.name = ''
        this.current.data = ''
      }
    }
  }
  </script>
  <style src="@/styles/pc.css" scoped>
  </style>
  <style scoped>
    .page-alert {
      background-color: rgba(0, 0, 0, 0.5);
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
    }
  
    .page-body {
      width: 500px;
    }
  
    .page-header {
      padding: 0 20px;
      height: 60px;
    }
  
    .page-options {
      border-bottom: 1px solid #eee;
    }
  
    .page-options-region-topic {
      height: 40px;
      padding: 0 20px;
    }
  
    .page-options-selection>div {
      padding: 0 6px;
      width: 40px;
      height: 40px;
    }
  
     .page-options-selection .line {
       height: 3px;
       width: 40px;
       bottom: 0;
     }
  
    .page-options-region-date{
      height: 40px;
      justify-content: end;
      padding: 0 16px;
    }
  
    .space {
      margin-right: 8px;
    }
  
    .page-content {
      height: 380px;
      overflow: hidden;
    }
  
    .page-footer {
      height: 60px;
    }
  
    .page-footer .btn {
      width: 100px;
      height: 30px;
      font-weight: 400;
      margin-right: 10px;
    }
  
    .page-footer .btn:last-child {
      margin: 0;
    }
  
    .page-options-region-person-pages {
      height: 24px;
      justify-content: end;
      padding: 0 20px;
    }
  
    .page-options-region-person-items {
      height: 24px;
      padding: 0 20px;
      margin-bottom: 10px;
    }
  
    .page-options-region-person-items .item {
      padding: 0 4px;
    }
  
    .page-options-region-person-items .item .p-line {
      left: 0;
      right: 0;
      bottom: -10px;
      height: 3px;
    }
  
    .menu-content-item-list-item-hg {
      height: 30px;
      padding: 0 10px;
    }
  
    .menu-content-item-list {
      padding: 10px;
      height: 100%;
      overflow: scroll;
    }
    .cate-sel-close {
      width: 30px;
      height: 30px;
    }
  
    .disabel {
      color: #999;
      cursor: not-allowed;
    }
  
     .character {
     margin-right: 6px;
     display: flex;
     align-items: flex-start;
     justify-content: flex-end;
    }
  
    .sel {
     background-color: rgba(147, 150, 156, 0.4);
    }
  
    .sel p {
      color: #fff;
    }
  
  </style>
  